import { render, staticRenderFns } from "./CurrencySelector.vue?vue&type=template&id=350e7394"
import script from "./CurrencySelector.vue?vue&type=script&lang=js"
export * from "./CurrencySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports